export default "__VITE_ASSET__DmqcA5PQ__"